import {openDialog} from 'platform/components';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';

import {
  FinancingEndingOperationDialog,
  type FinancingEndingOperationDialogProps,
} from '../components/FinancingEndingOperationDialog/FinancingEndingOperationDialog';

const FINANCING_ENDING_OPERATION_DIALOG_ID = 'financingEndingOperationDialog';

type OpenFinancingEndingOperationDialogParams = FinancingEndingOperationDialogProps & {
  onCloseComplete?: () => void;
};

export const openFinancingEndingOperationDialog = (
  params: OpenFinancingEndingOperationDialogParams
) =>
  openDialog(
    <FinancingEndingOperationDialog
      key={params.bulkOperationId}
      bulkOperationId={params.bulkOperationId}
      onRerunAccepted={params.onRerunAccepted}
      onUnmount={params.onUnmount}
    />,
    {
      id: FINANCING_ENDING_OPERATION_DIALOG_ID,
      title: i18n.t('entity.businessCase.financingEnding.operation.title'),
      size: 'large',
      withAdditionalFooter: true,
      'data-testid': testIds.businessCase.financingEnding('operationDialog'),
      onCloseComplete: params.onCloseComplete,
    }
  );
